"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuPopoverClassNames: ()=>menuPopoverClassNames,
    useMenuPopoverStyles_unstable: ()=>useMenuPopoverStyles_unstable
});
const _react = require("@griffel/react");
const menuPopoverClassNames = {
    root: 'fui-MenuPopover'
};
const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        Bbmb7ep: [
            "f1aa9q02",
            "f16jpd5f"
        ],
        Beyfa6y: [
            "f16jpd5f",
            "f1aa9q02"
        ],
        B7oj6ja: [
            "f1jar5jt",
            "fyu767a"
        ],
        Btl43ni: [
            "fyu767a",
            "f1jar5jt"
        ],
        De3pzq: "fxugw4r",
        sj55zd: "f19n0e5",
        Bf4jedk: "fkqu4gx",
        B2u0y6b: "f1kaai3v",
        a9b677: "f1ahpp82",
        E5pizo: "f1hg901r",
        z8tnut: "f10ra9hq",
        z189sj: [
            "f8wuabp",
            "fycuoez"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "fycuoez",
            "f8wuabp"
        ],
        B4j52fo: "f5ogflp",
        Bekrc4i: [
            "f1hqa2wf",
            "finvdd3"
        ],
        Bn0qgzm: "f1f09k3d",
        ibv6hh: [
            "finvdd3",
            "f1hqa2wf"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "figsok6",
        Bg96gwp: "f1i3iumi"
    }
}, {
    d: [
        ".f1aa9q02{border-bottom-right-radius:var(--borderRadiusMedium);}",
        ".f16jpd5f{border-bottom-left-radius:var(--borderRadiusMedium);}",
        ".f1jar5jt{border-top-right-radius:var(--borderRadiusMedium);}",
        ".fyu767a{border-top-left-radius:var(--borderRadiusMedium);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fkqu4gx{min-width:128px;}",
        ".f1kaai3v{max-width:300px;}",
        ".f1ahpp82{width:-webkit-max-content;width:-moz-max-content;width:max-content;}",
        ".f1hg901r{box-shadow:var(--shadow16);}",
        ".f10ra9hq{padding-top:4px;}",
        ".f8wuabp{padding-right:4px;}",
        ".fycuoez{padding-left:4px;}",
        ".f1y2xyjm{padding-bottom:4px;}",
        ".f5ogflp{border-top-width:1px;}",
        ".f1hqa2wf{border-right-width:1px;}",
        ".finvdd3{border-left-width:1px;}",
        ".f1f09k3d{border-bottom-width:1px;}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}"
    ]
});
const useMenuPopoverStyles_unstable = (state)=>{
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(menuPopoverClassNames.root, styles.root, state.root.className);
    return state;
}; //# sourceMappingURL=useMenuPopoverStyles.js.map

//# sourceMappingURL=useMenuPopoverStyles.js.map